//LL: 19.09.19:   PaletteListField.tsx  from SelectField

import * as React from 'react';
import * as _ from 'underscore';

import * as Utils from '../ts/Utilities'; //LL: 13.12.19

import { IGlob } from '../../../pdc-platform/src/ts/Glob'; //LL: 13.12.19

import { PaletteColors } from './PalettesField'; //LL: 13.12.19

export default class PaletteListField extends React.Component<
    {
        value?: string;
        allowNull?: boolean;
        nullOptionTitle?: string;
        disabled?: boolean;

        themeObj?: any;

        options?: {
            source?: any[];
            values?: any[];
            display?: string[];
            tooltips?: string[];
            builtinPalettes?: string[];

            themeFieldName_forCustomPalettes?: string;
        };

        onChange?(value: string);
        glob: IGlob;
    },
    { customPalettes; values; display }
> {
    private static customPrefix = '__custom';

    public static retrievePaletteOrColors(value, theme, customPalettesFieldName) {
        let result: any = value;

        //  val = name + PaletteListField.customPrefix + (colors as any).toString();
        let N = value.indexOf(PaletteListField.customPrefix);
        if (N >= 0) {
            let colors = [];
            let iStr = value.substr(N + 8);
            if (iStr !== '') {
                colors = iStr.split(',');
            }
            let paletteName = value.substr(0, N);

            let paletteVal;
            //LL:  find palette by name:
            if (paletteName != null && paletteName != '') {
                if (theme != null && theme[customPalettesFieldName] != null) {
                    let customPalettes = theme[customPalettesFieldName];
                    if (customPalettes != null) {
                        for (let i = 0; i < customPalettes.length; i++) {
                            if (customPalettes[i].name === paletteName) {
                                paletteVal = customPalettes[i].colors;
                                break;
                            }
                        }
                    }
                }
            }
            if (paletteVal == null) {
                paletteVal = colors;
            }

            result = paletteVal;
        } else {
            //result = { custom: false, name: value  };
        }

        return result;
    }

    //LL: 23.09.19:  for variant 3
    private static retrievePaletteName(value) {
        let result: string = value;

        //  val = name + PaletteListField.customPrefix + (colors as any).toString();
        let N = value.indexOf(PaletteListField.customPrefix);
        if (N >= 0) {
            let paletteName = value.substr(0, N);
            result = paletteName;
        }

        return result;
    }

    //LL: 23.09.19:  for variant 3
    private static retrievePaletteNameValue(value) {
        // with prefix, without colors
        let result: string = value;

        //  val = name + PaletteListField.customPrefix + (colors as any).toString();
        let N = value.indexOf(PaletteListField.customPrefix);
        if (N >= 0) {
            let paletteNameValue = value.substr(0, N + PaletteListField.customPrefix.length);
            result = paletteNameValue;
        }

        return result;
    }

    isCustomPalette(name) {
        //LL: 23.09.19: 3 variant:
        //   in render:  Remove concatenated colors from current value
        //  val = name + PaletteListField.customPrefix

        let N = name.indexOf(PaletteListField.customPrefix);
        return N >= 0;
    }

    getCustomPalette(name) {
        //LL: 23.09.19: 3 variant:
        //   in render:  Remove concatenated colors from current value
        //  val = name + PaletteListField.customPrefix

        let N = name.indexOf(PaletteListField.customPrefix);
        if (N >= 0) {
            return name.substr(0, N);
        } else {
            return null;
        }
    }

    createResultValue(value) {
        //LL: 23.09.19: 3 variant:
        //   "Values" are special prefix with custom palette name, without colors
        //    in handleChange:   Add colors to current value when call this.props.onChange(result)

        let result = value;

        if (value !== '') {
            let customPaletteName = this.getCustomPalette(value);
            if (customPaletteName != null) {
                let customPalettes = this.state.customPalettes;
                if (customPalettes != null) {
                    for (let i = 0; i < customPalettes.length; i++) {
                        if (customPalettes[i].name === customPaletteName) {
                            let colors = customPalettes[i].colors;
                            if (colors != null) {
                                result = value + (colors as any).toString();
                            }
                            break;
                        }
                    }
                }
            }
        }

        return result;
    }

    produceValueFromCustomPaletteColors(colors, name) {
        let val = '';

        //     2 variant:
        //if (Array.isArray(colors)) {
        //    val = name + PaletteListField.customPrefix + (colors as any).toString();
        //}

        //LL: 23.09.19: 3 variant:
        //   in render:  Remove concatenated colors from current value
        val = name + PaletteListField.customPrefix;

        return val;
    }

    private references: {
        control?: HTMLSelectElement;
    } = {};

    constructor(props) {
        super(props);

        let customPalettes;

        //LL: 23.09.19: "themeObj"  is from ThemeField.tsx  class EditComponentDepsWrapper.render
        if (this.props.themeObj != null) {
            let themeFieldName_forCustomPalettes = 'palette_set';
            if (this.props.options != null && this.props.options.themeFieldName_forCustomPalettes != null) {
                themeFieldName_forCustomPalettes = this.props.options.themeFieldName_forCustomPalettes;
            }
            customPalettes = this.props.themeObj[themeFieldName_forCustomPalettes]; //LL: array of { name, colors:[] }
            //console.log("PaletteListField constructor customPalettes = " + customPalettes);
        }

        let builtinPalettes: any = this.get_builtinPalettes() || [];
        let values: any = builtinPalettes.slice(0);
        let display: any = builtinPalettes.slice(0);

        this.state = {
            customPalettes: customPalettes,
            values: values,
            display: display
        };
    }

    get_builtinPalettes(): any[] {
        return this.props.options != null ? this.props.options.builtinPalettes : null;
    }

    handleChange = (e) => {
        const value = this.references.control.value; //LL: always string

        if (typeof this.props.onChange === 'function') {
            let result: any = value;

            if (value !== '') {
                //LL: no, bad when array, let value be always string - palette name or concatenated colors
                //let customColors = this.retrieveCustomPaletteColors(value);
                //if (customColors != null) {
                //    result = customColors;
                //}
            }
            //else if (this.props.allowNull === true) {
            //    result = null;
            //}

            //LL: 23.09.19: 3 variant:
            //   "values" are special prefix with custom palette name, without colors
            //    in handleChange:   Add colors to current value when call this.props.onChange(result)
            result = this.createResultValue(value);

            this.props.onChange(result);
        }
    };

    render() {
        //LL: 1 variant:
        //LL: this.props.value is palette name or array of colors
        //LL: bad when can be both string and array - error in mergeRecursive for Themes

        //LL: 2 variant:   THIS NOW
        //LL: this.props.value is palette name or string with color values and special prefix with custom palette name
        //    So, always string

        //LL: 3 variant:   TRY AFTER   23.09.19
        //LL: new: add option "builtinPalettes" with palette names, instead of values/display
        //LL: this.props.value is palette name or string with color values and special prefix with custom palette name
        //    So, always string
        //   But values for <option> are always "names", without concatenated "colors",
        //     with prefix ? or use "builtinPalettes" list ?
        //       in handleChange:   Add colors to current value when call this.props.onChange(result)
        //       in render:  Remove concatenated colors from current value
        //   "Values" are special prefix with custom palette name, without colors
        //   Otherwise, if colors of custom palette is changed, selected "value" <option> is not found !!

        let value = this.props.value || '';

        //LL: 23.09.19: 3 variant:
        //   in render:  Remove concatenated colors from current value
        value = PaletteListField.retrievePaletteNameValue(value);

        let options: any[];

        let customPalettes = this.state.customPalettes;

        let values: any = this.state.values.slice(0);

        if (values != null || customPalettes != null) {
            let display: any = this.state.display.slice(0);

            let tooltips; // = this.props.options != null ? this.props.options.tooltips : null;

            //LL: array of { name, colors:[] }
            if (customPalettes != null && customPalettes.length > 0) {
                if (values == null) values = [];
                if (display == null) display = [];
                //if (tooltips == null) tooltips = [];

                _.each(customPalettes, (obj: any, i) => {
                    display.push(obj.name);

                    //LL: 23.09.19: 3 variant:  val = name + PaletteListField.customPrefix
                    values.push(this.produceValueFromCustomPaletteColors(obj.colors, obj.name));

                    // tooltips
                });
            }

            options = _.map(
                values,
                (val: any, i) => {
                    const text = display != null && display[i] != null ? display[i] : value.toString();
                    const tooltip = tooltips != null && tooltips[i] != null && tooltips[i] !== '' ? tooltips[i] : '';

                    //LL: 06.12.19: try.  No, you cannot do it. Only text
                    ////let T = <span> { text } </span>;
                    //let divColor =
                    //    <div style={{ display: "inline-block", width: "10px", height: "10px", backgroundColor: "red" }}>
                    //    </div>;
                    //let T =
                    //    <span>
                    //        { text + " XXX " }
                    //        { divColor }
                    //    </span>;
                    ////   { T }

                    return (
                        <option key={i} value={val} title={tooltip}>
                            {text}
                        </option>
                    );
                },
                this
            );
        }

        let nullOption;
        if (this.props.allowNull === true && options != null && options.length > 0) {
            nullOption = (
                <option key={'null value'} value={''}>
                    {this.props.nullOptionTitle}
                </option>
            );
        }

        //LL: 15.12.19:
        let showColorsFlag = true; //LL: my flag
        //let showColorsFlag = false;  //LL: my flag
        let colorsElem;
        if (showColorsFlag) {
            let colors;
            if (value !== '') {
                let customPaletteName = this.getCustomPalette(value);
                if (customPaletteName != null) {
                    let customPalettes = this.state.customPalettes;
                    if (customPalettes != null) {
                        for (let i = 0; i < customPalettes.length; i++) {
                            if (customPalettes[i].name === customPaletteName) {
                                colors = customPalettes[i].colors;
                                break;
                            }
                        }
                    }
                } else {
                    //  built-in
                    let p = Utils.getDevExpressPaletteColors(value);
                    if (p != null) {
                        colors = p;
                    }
                }
            }

            if (colors != null && colors.length > 0) {
                //LL:  readOnly -> without "cog" glyph
                colorsElem = (
                    <PaletteColors
                        value={colors}
                        readOnly={true}
                        themeObj={this.props.themeObj}
                        onChange={null}
                        glob={this.props.glob}
                    />
                );
            } else {
                colorsElem = 'empty palette';
            }
        }

        return (
            <div className="palette-list-field">
                <div className="select-field">
                    <select
                        className="form-control"
                        ref={(input) => {
                            this.references.control = input;
                        }}
                        value={value}
                        disabled={this.props.disabled}
                        onChange={this.handleChange}
                        tabIndex={0}
                    >
                        {nullOption}
                        {options}
                    </select>
                </div>
                <div className="colors-field">{colorsElem}</div>
            </div>
        );
    }
}
